export default __webpack_public_path__ + "static/media/374D.505c2868.pdf";